var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9a79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff3340"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff3340"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Custom_Size_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom_Size_1",
    "data-name": "Custom Size \\u2013 1",
    clipPath: "url(#clip-Custom_Size_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M0,98.275,98.275,0H368.533A24.569,24.569,0,0,1,393.1,24.569V368.533A24.569,24.569,0,0,1,368.533,393.1H24.569A24.569,24.569,0,0,1,0,368.533Z",
    fill: "url(#linear-gradient3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M98.275,0V73.707A24.569,24.569,0,0,1,73.707,98.275H0Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M-89.775-27.759V0h-19.266V-83.049h29.3a48.315,48.315,0,0,1,15.076,2.08A28.933,28.933,0,0,1-54.293-75.24a22.334,22.334,0,0,1,6.014,8.607,29.182,29.182,0,0,1,1.938,10.716,31.507,31.507,0,0,1-1.995,11.4,22.876,22.876,0,0,1-6.1,8.892,28.741,28.741,0,0,1-10.4,5.785,47.682,47.682,0,0,1-14.906,2.081Zm0-14.535h10.032q7.524,0,10.83-3.591t3.306-10.032a15,15,0,0,0-.855-5.187,10.555,10.555,0,0,0-2.593-4.019,11.66,11.66,0,0,0-4.389-2.593,19.413,19.413,0,0,0-6.3-.912H-89.775Zm134.292.741A43.548,43.548,0,0,1,41.41-24.938a38.873,38.873,0,0,1-8.749,13.167A39.683,39.683,0,0,1,19.066-3.107,48.106,48.106,0,0,1,1.425,0H-30.837V-83.049H1.425a47.716,47.716,0,0,1,17.641,3.135A40.255,40.255,0,0,1,32.661-71.25,38.57,38.57,0,0,1,41.41-58.111,43.394,43.394,0,0,1,44.517-41.553Zm-19.722,0a36.181,36.181,0,0,0-1.6-11.115,23.747,23.747,0,0,0-4.589-8.408,19.926,19.926,0,0,0-7.325-5.3,24.868,24.868,0,0,0-9.861-1.853H-11.457V-14.82H1.425a24.868,24.868,0,0,0,9.861-1.852,19.926,19.926,0,0,0,7.325-5.3A23.747,23.747,0,0,0,23.2-30.381,36.385,36.385,0,0,0,24.8-41.553Zm87.894-41.5v14.82H78.6V-47.2h28.386v14.877H78.6V0H59.223V-83.049Z",
    transform: "translate(194 231)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf_icon.202b795378cf43e8c3b27d3d5053249a.svg";
export { ForwardRef as ReactComponent };